<template>
  <div class="card">
    <header v-if="title" class="card-header" :class="{ 'is-clickable': collapsible }" @click="toggleCollapse">
      <p class="card-header-title">
        <b-icon v-if="icon" :icon="icon" custom-size="default" />
        {{ title }}
      </p>
      <slot name="header-right"></slot>
      <!-- Collapse toggle arrow -->
      <a
        v-if="collapsible"
        href="#"
        class="card-header-icon"
        aria-label="toggle collapse"
        @click.prevent.stop="toggleCollapse"
      >
        <b-icon :icon="isCollapsed ? 'chevron-down' : 'chevron-up'" custom-size="default" />
      </a>
      <a
        v-else-if="headerIcon"
        href="#"
        class="card-header-icon"
        aria-label="more options"
        @click.prevent="headerIconClick"
      >
        <b-icon :icon="headerIcon" custom-size="default" />
      </a>
    </header>
    <transition name="collapse">
      <div v-show="!isCollapsed" class="card-content">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'CardComponent',
  props: {
    title: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    headerIcon: {
      type: String,
      default: null
    },
    collapsible: {
      type: Boolean,
      default: false
    },
    startCollapsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isCollapsed: this.startCollapsed
    }
  },
  methods: {
    headerIconClick() {
      this.$emit('header-icon-click')
    },
    toggleCollapse() {
      if (this.collapsible) {
        this.isCollapsed = !this.isCollapsed
        this.$emit('collapse-toggle', this.isCollapsed)
      }
    }
  }
}
</script>

<style scoped>
.is-clickable {
  cursor: pointer;
}

.is-clickable:hover {
  background-color: #f5f5f5;
}

/* Collapse transition */
.collapse-enter-active,
.collapse-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
}

.collapse-enter,
.collapse-leave-to {
  opacity: 0;
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
